var map = {
	"./tham_back1.png": 44736,
	"./tham_back2.png": 1850,
	"./tham_back3.png": 39975,
	"./tham_back4.png": 95200,
	"./tham_back5.png": 70214,
	"./tham_back6.png": 96845,
	"./tham_back7.png": 36566,
	"./tham_back8.png": 80010,
	"./tham_back9.png": 8336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45797;